import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DropDownMenu from './DropDownMenu';
import InputType from './InputType';
import theme from '../../theme';

const DropDownButton = ({
  children,
  options,
  onClick,
  showArrow,
  align,
  ...props
}) => {
  let anchor;
  return React.Children.map(children, child => React.cloneElement(child, {
    ...props,
    ref: ref => { anchor = ref; },
    onClick: e => {
      e.preventDefault();
      DropDownMenu.open(e, options.map(
        ({ type = 'buttons', active, options: inner }, i) => ({
          _id: `${type}.${i}`,
          type,
          active,
          options: inner.map(((option, j) => ({
            ...option,
            _id: `${type}.${i}.${j}`,
          }))),
        }),
      ), {
        anchor,
        showArrow,
        align,
      });
      if (onClick) {
        onClick(e);
      }
    },
  }));
};
DropDownButton.propTypes = {
  children: PropTypes.node,
  options: InputType,
  onClick: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.string,
  showArrow: PropTypes.bool,
  align: PropTypes.oneOf(['left', 'center', 'right']),
};
DropDownButton.defaultProps = {
  children: null,
  options: [],
  onClick: null,
  className: null,
  type: 'button',
  showArrow: false,
  align: null,
};

export default styled(DropDownButton)`
  cursor: pointer;
  user-select: none;

  &::after {
    border-bottom: solid 1px ${theme.colors.gray6};
    border-right: solid 1px ${theme.colors.gray6};
    content: '';
    display: inline-block;
    height: ${theme.unit * 0.75}px;
    margin-left: ${theme.unit}px;
    transform: translate(-2px, -${theme.unit / 2}px) rotate(45deg);
    transform-origin: center;
    width: ${theme.unit * 0.75}px;
  }

  &:focus {
    &::after {
      transform: translate(-2px, 0) rotate(225deg);
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/stateful/DropDown/DropDownButton.js